import Check from '@/assets/Builder/AcknowledgementIcons/Check.vue';
import CheckCircle from '@/assets/Builder/AcknowledgementIcons/CheckCircle.vue';
import MessageDotsCircle from '@/assets/Builder/AcknowledgementIcons/MessageDotsCircle.vue';
import MessageSmileSquare from '@/assets/Builder/AcknowledgementIcons/MessageSmileSquare.vue';
import Bubble1InActive from '@/assets/Builder/ChatBubbles/Bubble1Inactive.vue';
import Bubble2Inactive from '@/assets/Builder/ChatBubbles/Bubble2Inactive.vue';
import MessageChatCircle from '@/assets/Builder/ChatIcons/MessageChatCircle.vue';
import MessageChatSquare from '@/assets/Builder/ChatIcons/MessageChatSquare.vue';
import MessageDotsCircleChatIcon from '@/assets/Builder/ChatIcons/MessageDotsCircle.vue';
import MessageSquare from '@/assets/Builder/ChatIcons/MessageSquare.vue';
import MessageWhatsApp from '@/assets/Builder/ChatIcons/MessageWhatsApp.vue';
import Blue from '@/assets/Builder/Themes/Blue.vue';
import Custom from '@/assets/Builder/Themes/Custom.vue';
import Golden from '@/assets/Builder/Themes/Golden.vue';
import Lavender from '@/assets/Builder/Themes/Lavender.vue';
import Tan from '@/assets/Builder/Themes/Tan.vue';
import Teal from '@/assets/Builder/Themes/Teal.vue';
import BottomLeft from '@/assets/Builder/WidgetPositions/BottomLeft.vue';
import BottomRight from '@/assets/Builder/WidgetPositions/BottomRight.vue';
import CenterLeft from '@/assets/Builder/WidgetPositions/CenterLeft.vue';
import CenterRight from '@/assets/Builder/WidgetPositions/CenterRight.vue';
import TopLeft from '@/assets/Builder/WidgetPositions/TopLeft.vue';
import TopRight from '@/assets/Builder/WidgetPositions/TopRight.vue';
import { i18n } from '@/plugin/vue-i18n';
// all emitting events
export const EMIT_EVENTS = {
    SELECT: 'select',
    SUBMIT: 'submit',
    CLOSE: 'close',
    PREVIEW: 'preview',
    ACTION: 'action',
    UPDATE_TITLE: 'update:title',
    SAVE_CHAT_WIDGET: 'save:chat-widget',
    UPDATE_IMAGE: 'update:image',
};
// all chat widget component IDs
export const CHAT_WIDGET_IDS = {
    LIST_ACTION_DROPDOWN: 'pg-chat-widget-list-page-list-action-dropdown',
    LIST_HEADER: 'pg-chat-widget-list-page-header',
    LIST_TABLE: 'pg-chat-widget-list-page-table',
    LIST_TABLE_EMPTY: 'pg-chat-widget-list-page-empty',
    MODAL_DEFAULT: 'pg-chat-widget-modal-default',
    DELETE_CHAT_WIDGET_MODAL: 'pg-chat-widget-delete-chat-widget-modal',
    MODAL_FOOTER_DEFAULT: 'pg-chat-widget-modal-footer-default',
    MODAL_HEADER: 'pg-chat-widget-modal-header',
    CLONE_CHAT_WIDGET_MODAL: 'pg-chat-widget-clone-chat-widget-modal',
    CLONE_CHAT_WIDGET_MODAL_INPUT: 'pg-chat-widget-clone-chat-widget-input',
    HEADER_BACK_BUTTON: 'pg-chat-widget-header-back-button',
    HEADER_EDIT_TITLE_BUTTON: 'pg-chat-widget-header-edit-title-button',
    HEADER_SAVE_BUTTON: 'pg-chat-widget-header-save-button',
    HEADER_PREVIEW_BUTTON: 'pg-chat-widget-header-preview-button',
    HEADER_ACTION_DROPDOWN: 'pg-chat-widget-header-action-button',
    CHAT_WIDGET_LABEL_INPUT: 'pg-chat-widget-label-input',
    CHAT_WIDGET_GET_CODE_BUTTON: 'pg-chat-widget-get-code-button',
    CHAT_WIDGET_MEDIA_UPLOADER: 'pg-chat-widget-btn-media-upload-edit',
    CHAT_WIDGET_AVATAR: 'pg-chat-widget-avatar',
    CHAT_WIDGET_BUTTON: 'pg-chat-widget-button',
    CHAT_WIDGET_WORDPRESS: 'pg-chat-widget-wordpress-button',
    CHAT_WIDGET_OPEN_HOURS: 'pg-chat-widget-open-hours',
    CHAT_WIDGET_SELECT_BUTTON: 'pg-chat-widget-select-button',
    CHAT_WIDGET_CHECKBOX: 'pg-chat-widget-checkbox',
};
// list page table action keys
export const TABLE_ACTION_KEYS = {
    DELETE: 'delete',
    EDIT: 'edit',
    CLONE: 'clone',
};
// list page table actions
export const MODAL_DEFAULTS = {
    show: false,
    loading: false,
    message: '',
    type: 'primary',
    title: '',
    submitText: 'Submit',
    cancelText: 'Cancel',
    id: CHAT_WIDGET_IDS.MODAL_DEFAULT,
    chatWidgetName: '',
};
// chat widget routes
export const CHAT_WIDGET_ROUTES = {
    LIST_PAGE: 'chat-widget',
    BUILDER_PAGE: 'chat-widget-builder',
};
// list table keys
export const LIST_TABLE_KEYS = {
    KEY: '_id',
    DEFAULT: 'default',
    NAME: 'name',
    CHAT_TYPE: 'chatType',
    ACTIONS: 'actions',
    UPDATED_AT: 'updatedAt',
    UPDATED_BY: 'updatedBy',
};
export const SIDEBAR_TAB_KEYS = {
    WIDGET: 'Widget',
    CHAT_WINDOW: 'Chat Window',
    MESSAGING: 'Messaging',
};
// builder
export const ChatType = {
    LIVE_CHAT: 'liveChat',
    WA_CHAT: 'waChat',
    EMAIL_CHAT: 'emailChat',
};
export const FallBackTimeOptions = [
    { value: '2', label: '2 mins' },
    { value: '5', label: '5 mins' },
    { value: '10', label: '10 mins' },
    { value: '15', label: '15 mins' },
];
export const ContactFormOptions = [
    {
        id: '1',
        value: 'name',
        label: 'Name',
        disabled: true,
        dataType: 'TEXT',
        fieldKey: 'contact.name',
        placeholder: 'Name',
    },
    {
        id: '2',
        value: 'phone',
        label: 'Phone',
        dataType: 'PHONE',
        fieldKey: 'contact.phone',
        placeholder: 'Phone',
    },
    {
        id: '3',
        value: 'email',
        label: 'Email',
        dataType: 'EMAIL',
        fieldKey: 'contact.email',
        placeholder: 'Email',
    },
    {
        id: '4',
        value: 'message',
        label: 'Message',
        dataType: 'LARGE_TEXT',
        fieldKey: 'contact.message',
        placeholder: 'Message',
    },
];
export const LocaleOptions = [
    { value: 'location', label: 'Use Location language' },
    { value: 'auto', label: 'Use Website language' },
    { value: 'en-us', label: 'English (United States)' },
    { value: 'en-gb', label: 'English (United Kingdom)' },
    { value: 'de', label: 'German (Germany)' },
    { value: 'fr-fr', label: 'French (France)' },
    { value: 'nl', label: 'Dutch (Netherlands)' },
    { value: 'hu', label: 'Hungarian (Hungary)' },
    { value: 'pt-pt', label: 'Portuguese (Portugal)' },
    { value: 'pt-br', label: 'Portuguese (Brazil)' },
    { value: 'es', label: 'Spanish (Spain)' },
    { value: 'fr-ca', label: 'French (Canada)' },
    { value: 'hr', label: 'Croatian (Croatia)' },
    { value: 'it', label: 'Italian (Italy)' },
    { value: 'sv-se', label: 'Swedish (Sweden)' },
    { value: 'da-dk', label: 'Danish (Denmark)' },
    { value: 'fi', label: 'Finnish (Finland)' },
    { value: 'no', label: 'Norwegian (Norway)' },
];
export const ChatBubbleType = {
    AVATAR: 'avatar',
    NORMAL: 'normal',
};
export const ChatBubbleOptions = [
    { value: ChatBubbleType.AVATAR, icon: Bubble1InActive },
    { value: ChatBubbleType.NORMAL, icon: Bubble2Inactive },
];
export const CHAT_ICONS = {
    MESSAGE_CHAT_CIRCLE: 'messageChatCircle',
    MESSAGE_CHAT_SQUARE: 'messageChatSquare',
    MESSAGE_SQUARE: 'messageSquare',
    MESSAGE_DOTS_CIRCLE: 'messageDotsCircle',
    MESSAGE_WHATSAPP: 'messageWhatsApp',
};
export const ACK_ICONS = {
    CHECK: 'Check',
    CHECK_CIRCLE: 'CheckCircle',
    MESSAGE_DOTS_CIRCLE: 'MessageDotsCircle',
    MESSAGE_SMILE_SQUARE: 'MessageSmileSquare',
};
export const ChatIconOptions = [
    {
        value: CHAT_ICONS.MESSAGE_CHAT_CIRCLE,
        icon: MessageChatCircle,
    },
    { value: CHAT_ICONS.MESSAGE_CHAT_SQUARE, icon: MessageChatSquare },
    { value: CHAT_ICONS.MESSAGE_SQUARE, icon: MessageSquare },
    { value: CHAT_ICONS.MESSAGE_DOTS_CIRCLE, icon: MessageDotsCircleChatIcon },
    { value: CHAT_ICONS.MESSAGE_WHATSAPP, icon: MessageWhatsApp },
];
export const ThemeName = {
    BLUE: 'blue',
    TEAL: 'teal',
    TAN: 'tan',
    LAVENDER: 'lavender',
    GOLDEN: 'golden',
    CUSTOM: 'custom',
};
export const DefaultTheme = {
    [ThemeName.BLUE]: {
        name: ThemeName.BLUE,
        value: ThemeName.BLUE,
        colors: {
            chatBubbleColor: '#155EEF',
            backgroundColor: '#ffffff',
            headerColor: '#0040C1',
            buttonColor: '#155EEF',
            avatarBackgroundColor: '#ffffff',
            avatarBorderColor: '#155EEF',
            senderMessageColor: '#155EEF',
            receivedMessageColor: '#F2F4F7',
        },
        typography: {
            fontFamily: 'Roboto',
            colors: {
                senderMessageTextColor: '#ffffff',
                receivedMessageTextColor: '#111828',
                systemMessageTextColor: '#344054',
                headerMessageTextColor: '#ffffff',
                welcomeMessageTextColor: '#344054',
            },
        },
    },
};
export const WhatsappTheme = {
    [ThemeName.CUSTOM]: {
        name: ThemeName.CUSTOM,
        value: ThemeName.CUSTOM,
        colors: {
            chatBubbleColor: '#128C7E',
            backgroundColor: '#E6DCD4',
            headerColor: '#128C7E',
            buttonColor: '#128C7E',
            avatarBackgroundColor: '#FFFFFF',
            avatarBorderColor: '#128C7E',
            senderMessageColor: '#DEF9C7',
            receivedMessageColor: '#FFFFFF',
        },
        typography: {
            fontFamily: 'Roboto',
            colors: {
                senderMessageTextColor: '#101828',
                receivedMessageTextColor: '#101828',
                systemMessageTextColor: '#101828',
                headerMessageTextColor: '#ffffff',
                welcomeMessageTextColor: '#344054',
            },
        },
    },
};
export const DefaultThemes = Object.assign(Object.assign({}, DefaultTheme), { [ThemeName.TEAL]: {
        name: ThemeName.TEAL,
        value: ThemeName.TEAL,
        colors: {
            chatBubbleColor: '#039855',
            backgroundColor: '#ffffff',
            headerColor: '#05603A',
            buttonColor: '#039855',
            avatarBackgroundColor: '#ffffff',
            avatarBorderColor: '#039855',
            senderMessageColor: '#039855',
            receivedMessageColor: '#F2F4F7',
        },
        typography: {
            fontFamily: `Roboto`,
            colors: {
                senderMessageTextColor: '#ffffff',
                receivedMessageTextColor: '#111828',
                systemMessageTextColor: '#344054',
                headerMessageTextColor: '#ffffff',
                welcomeMessageTextColor: '#344054',
            },
        },
    }, [ThemeName.TAN]: {
        name: ThemeName.TAN,
        value: ThemeName.TAN,
        colors: {
            chatBubbleColor: '#E04F16',
            backgroundColor: '#ffffff',
            headerColor: '#932F19',
            buttonColor: '#E04F16',
            avatarBackgroundColor: '#ffffff',
            avatarBorderColor: '#E04F16',
            senderMessageColor: '#E04F16',
            receivedMessageColor: '#F2F4F7',
        },
        typography: {
            fontFamily: `Roboto`,
            colors: {
                senderMessageTextColor: '#ffffff',
                receivedMessageTextColor: '#111828',
                systemMessageTextColor: '#344054',
                headerMessageTextColor: '#ffffff',
                welcomeMessageTextColor: '#344054',
            },
        },
    }, [ThemeName.GOLDEN]: {
        name: ThemeName.GOLDEN,
        value: ThemeName.GOLDEN,
        colors: {
            chatBubbleColor: '#CA8504',
            backgroundColor: '#ffffff',
            headerColor: '#854A0E',
            buttonColor: '#CA8504',
            avatarBackgroundColor: '#ffffff',
            avatarBorderColor: '#CA8504',
            senderMessageColor: '#CA8504',
            receivedMessageColor: '#F2F4F7',
        },
        typography: {
            fontFamily: `Roboto`,
            colors: {
                senderMessageTextColor: '#ffffff',
                receivedMessageTextColor: '#111828',
                systemMessageTextColor: '#344054',
                headerMessageTextColor: '#ffffff',
                welcomeMessageTextColor: '#344054',
            },
        },
    }, [ThemeName.LAVENDER]: {
        name: ThemeName.LAVENDER,
        value: ThemeName.LAVENDER,
        colors: {
            chatBubbleColor: '#6938EF',
            backgroundColor: '#ffffff',
            headerColor: '#4A1FB8',
            buttonColor: '#6938EF',
            avatarBackgroundColor: '#ffffff',
            avatarBorderColor: '#6938EF',
            senderMessageColor: '#6938EF',
            receivedMessageColor: '#F2F4F7',
        },
        typography: {
            fontFamily: `Roboto`,
            colors: {
                senderMessageTextColor: '#ffffff',
                receivedMessageTextColor: '#111828',
                systemMessageTextColor: '#344054',
                headerMessageTextColor: '#ffffff',
                welcomeMessageTextColor: '#344054',
            },
        },
    }, [ThemeName.CUSTOM]: {
        name: ThemeName.CUSTOM,
        value: ThemeName.CUSTOM,
        colors: DefaultTheme[ThemeName.BLUE].colors,
        typography: DefaultTheme[ThemeName.BLUE].typography,
    } });
export const ThemeIcons = {
    [ThemeName.BLUE]: Blue,
    [ThemeName.TEAL]: Teal,
    [ThemeName.TAN]: Tan,
    [ThemeName.LAVENDER]: Lavender,
    [ThemeName.GOLDEN]: Golden,
    [ThemeName.CUSTOM]: Custom,
};
export const ThemeOptions = Object.values(DefaultThemes);
export var WidgetPositions;
(function (WidgetPositions) {
    WidgetPositions["TOP_LEFT"] = "top-left";
    WidgetPositions["TOP_CENTER"] = "top-center";
    WidgetPositions["TOP_RIGHT"] = "top-right";
    WidgetPositions["BOTTOM_LEFT"] = "bottom-left";
    WidgetPositions["BOTTOM_CENTER"] = "bottom-center";
    WidgetPositions["BOTTOM_RIGHT"] = "bottom-right";
    WidgetPositions["MIDDLE_LEFT"] = "middle-left";
    WidgetPositions["MIDDLE_CENTER"] = "middle-center";
    WidgetPositions["MIDDLE_RIGHT"] = "middle-right";
})(WidgetPositions || (WidgetPositions = {}));
export const WidgetPositionOptions = [
    { value: WidgetPositions.BOTTOM_RIGHT, icon: BottomRight },
    { value: WidgetPositions.TOP_LEFT, icon: TopLeft },
    { value: WidgetPositions.BOTTOM_LEFT, icon: BottomLeft },
    { value: WidgetPositions.MIDDLE_LEFT, icon: CenterLeft },
    { value: WidgetPositions.TOP_RIGHT, icon: TopRight },
    { value: WidgetPositions.MIDDLE_RIGHT, icon: CenterRight },
];
export const acknowledgementIconsOptions = [
    {
        value: ACK_ICONS.CHECK,
        icon: Check,
    },
    {
        value: ACK_ICONS.CHECK_CIRCLE,
        icon: CheckCircle,
    },
];
export const acknowledgementIconsLiveChatOptions = [
    {
        value: ACK_ICONS.MESSAGE_DOTS_CIRCLE,
        icon: MessageDotsCircle,
    },
    {
        value: ACK_ICONS.MESSAGE_SMILE_SQUARE,
        icon: MessageSmileSquare,
    },
];
export const ThemeCustomColorOptions = {
    CHAT_BUBBLE_COLOR: 'chatBubbleColor',
    BACKGROUND_COLOR: 'backgroundColor',
    HEADER_COLOR: 'headerColor',
    BUTTON_COLOR: 'buttonColor',
    AVATAR_BACKGROUND_COLOR: 'avatarBackgroundColor',
    AVATAR_BORDER_COLOR: 'avatarBorderColor',
    SENDER_MESSAGE_COLOR: 'senderMessageColor',
    RECEIVED_MESSAGE_COLOR: 'receivedMessageColor',
};
export const TypographyColorOptions = {
    SENDER_MESSAGE_TEXT_COLOR: 'senderMessageTextColor',
    RECEIVED_MESSAGE_TEXT_COLOR: 'receivedMessageTextColor',
    SYSTEM_MESSAGE_TEXT_COLOR: 'systemMessageTextColor',
    HEADER_MESSAGE_TEXT_COLOR: 'headerMessageTextColor',
    WELCOME_MESSAGE_TEXT_COLOR: 'welcomeMessageTextColor',
};
export const ChatWidgetSettingsDataOptions = {
    SHOW_PROMPT_TYPE: 'promptType',
    CHAT_ICON: 'chatIcon',
    PROMPT_AVATAR_ALT_TEXT: 'promptAvatarAltText',
    IS_PROMPT_AVATAR_IMAGE_OPTIMIZE: 'isPromptAvatarImageOptimize',
    PROMPT_MSG: 'promptMsg',
    REVISIT_PROMPT_MSG: 'revisitPromptMsg',
    AGENCY_NAME: 'agencyName',
    BRANDING_TITLE: 'brandingTitle',
    AGENCY_WEBSITE: 'agencyWebsite',
    LEGAL_MSG: 'legalMsg',
    SHOW_AGENCY_BRANDING: 'showAgencyBranding',
    SHOW_CONSENT_CHECKBOX: 'showConsentCheckbox',
    SUB_HEADING: 'subHeading',
    LIVE_CHAT_USER_INACTIVE_TIME: 'liveChatUserInactiveTime',
    LIVE_CHAT_INTRO_MSG: 'liveChatIntroMsg',
    HEADING: 'heading',
    LIVE_CHAT_VISITOR_INACTIVE_TIME: 'liveChatVisitorInactiveTime',
    SEND_ACTION_TEXT: 'sendActionText',
    WA_NUMBER: 'waNumber',
    SUPPORT_CONTACT: 'supportContact',
    SUCCESS_MSG: 'successMsg',
    LIVE_CHAT_ACK_MSG: 'liveChatAckMsg',
    THANK_YOU_MSG: 'thankYouMsg',
    LIVE_CHAT_FEEDBACK_NOTE: 'liveChatFeedbackNote',
    LIVE_CHAT_ENDED_MSG: 'liveChatEndedMsg',
    LOCALE: 'locale',
    SHOW_PROMPT: 'showPrompt',
    LIVE_CHAT_USER_INACTIVE_MSG: 'liveChatUserInactiveMsg',
    LIVE_CHAT_VISITOR_INACTIVE_MSG: 'liveChatVisitorInactiveMsg',
    LIVE_CHAT_FEEDBACK_MSG: 'liveChatFeedbackMsg',
    ALLOW_AVATAR_IMAGE: 'allowAvatarImage',
    REPRESENTATIVE_ASSIGNED_MESSAGE: 'representativeAssignedMessage',
    ENABLE_REVISIT_MESSAGE: 'enableRevisitMessage',
    SHOW_LIVE_CHAT_WELCOME_MSG: 'showLiveChatWelcomeMsg',
    CONTACT_FORM_OPTIONS: 'contactFormOptions',
    ENABLE_CONTACT_FORM: 'enableContactForm',
    REDIRECT_ACTION: 'redirectAction',
    REDIRECT_WEBSITE: 'redirectWebsite',
    REDIRECT_TEXT: 'redirectText',
    DEFAULT_CONSENT_CHECK: 'defaultConsentCheck',
    USE_EMAIL_FIELD: 'useEmailField',
};
export const SuccessAcknowledgementBGColor = '#12b76a';
export const IMAGE_CDN_PREFIX = 'https://images.leadconnectorhq.com/image/f_webp/q_100/r_180/u_';
export function customTypographyData() {
    return [
        {
            title: i18n.global.t('sidebar.senderMessageTextColor'),
            helper: i18n.global.t('sidebar.senderMessageTextColorHelper'),
        },
        {
            title: i18n.global.t('sidebar.receivedMessageTextColor'),
            helper: i18n.global.t('sidebar.receivedMessageTextColorHelper'),
        },
        {
            title: i18n.global.t('sidebar.headerMessageTextColor'),
            helper: i18n.global.t('sidebar.headerMessageTextColorHelper'),
        },
        {
            title: i18n.global.t('sidebar.systemMessageTextColor'),
            helper: i18n.global.t('sidebar.systemMessageTextColorHelper'),
        },
        {
            title: i18n.global.t('sidebar.welcomeMessageTextColor'),
            helper: i18n.global.t('sidebar.welcomeMessageTextColorHelper'),
        },
    ];
}
export function customTypographyColumns() {
    return [
        { title: i18n.global.t('sidebar.tableColumnNameCategory'), key: 'title' },
        {
            title: i18n.global.t('sidebar.tableColumnNameDescription'),
            key: 'helper',
        },
    ];
}
export const LEVEL_UP_AGENCY_IDS = [
    'pfpm9iFi4k5yvjnstXWU',
    'ktapXmiRvMM4pJHyN3b3',
    'YuTUZlUtrwBtvmgByZDW',
    '5DP4iH6HLkQsiKESj6rh',
];
export const LEVEL_UP_DATE = '2024-10-22T10:00:00+05:30';
